// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__1ks_2","avatarWrap":"Bio_avatarWrap__1TrDI","content":"Bio_content__duFf9","text":"Bio_text__2qd5w"};